import {h, Component, Fragment} from "preact";

import formatOdd from "../../../services/odds-format";


export function CardHeaderRow({children}) {
	return <div class="cl-pt-card-head-row flex h-10 rounded-t-lg items-center bg-kobaaccent-400 text-slate-950">{children}</div>
}

export function ThreeDots() {
	return <div class="cl-pt-3-dots flex h-full px-2">
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-slate-950"></div></div>
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-slate-950"></div></div>
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-slate-950"></div></div>
	</div>
}

export function OneDotAlt() {
	return <div class="cl-pt-1-dot-alt flex h-full px-2">
	  <div class="flex h-full w-2 flex-none items-center justify-center"><div class="h-1 w-1 rounded-full bg-kobaaccent-500"></div></div>
	</div>
}

export function CardHeaderTitle({children}) {
	return <div class="cl-pt-card-head-ttl min-w-0 grow truncate text-sm">{children}</div>
}

export function CardHeaderSports({children}) {
	return <div class="cl-pt-card-head-sports flex h-full text-sm">{children}</div>
}
export function SportNameButton({children, active, onClick}) {
	if (active)
		return <div class="cl-pt-sprt-name-btn flex items-center border-l border-l-zinc-950 px-3 bg-zinc-900 text-white" onClick={onClick}>{children}</div>
	return <div class="cl-pt-sprt-name-btn flex items-center border-l border-l-zinc-950 px-3" onClick={onClick}>{children}</div>
}


export function OddsTableHeadRow({children}) {
	return <div class="cl-pt-odd-tab-h-row flex h-6 items-center bg-slate-100 text-xs leading-tight text-slate-950">{children}</div>
}
export function HeadRowCellId({children, onClick}) {
	return <div class="cl-pt-h-row-cell-id flex h-full w-9 items-center justify-center text-center" onClick={onClick}>{children}</div>
}
export function HeadRowCellTime({children, onClick}) {
	return <div class="cl-pt-h-row-cell-time flex h-full w-11 items-center justify-center text-center" onClick={onClick}>{children}</div>
}
export function HeadRowCellEvent({children, onClick}) {
	return <div class="cl-pt-h-row-cell-evt flex h-full min-w-0 grow items-center justify-center text-center" onClick={onClick}>{children}</div>
}
export function ContentRowCellEvent({children, onClick}) {
	return <div class="cl-pt-cont-row-cell-evt flex h-full min-w-0 grow items-center" onClick={onClick}>{children}</div>
}

export function HeadOddCell({children}) {
	return <div class="cl-pt-h-odd-cell flex h-full w-1/2 items-center justify-center text-center truncate">
		<span class="truncate">{children}</span>
	</div>
}
export function HeadMoreCell({children}) {
	return <div class="cl-pt-h-more-cell flex h-full w-9 flex-none items-center justify-center text-center">{children}</div>
}


export function OddsWidthContainer({children}) {
	return <div class="cl-pt-ow-cont flex h-full w-2/5 flex-none">{children}</div>
}
export function OddsWidthContainerLarge({children}) {
	return <div class="cl-pt-ow-cont-lg flex h-full w-3/5 gap-2 flex-none font-bold text-sm text-kobaaccent-500">{children}</div>
}
export function OddsWidthEmpty({children}) {
	return <div class="cl-pt-ow-empt flex h-full grow">{children}</div>
}


export function EventRow({children, isOdd}) {
	return <div class={"cl-pt-evt-row flex h-14 py-2 border-b border-b-slate-300 text-sm text-slate-950 "+(isOdd ? "bg-slate-100" : "bg-slate-200")}>{children}</div>
}

export function EventOddButton({value, active, onClick, selected}) {
	if (selected)
		return <div class="cl-pt-evt-odd-btn flex h-full w-1/2 items-center justify-center rounded-full border border-kobaaccent-400 text-center font-bold text-slate-950 bg-kobaaccent-400 cursor-pointer" onClick={onClick}>
			{!!value ? formatOdd(value) : '-'}
		</div>
	return <div class="cl-pt-evt-odd-btn flex h-full w-1/2 items-center justify-center rounded-full border border-kobaaccent-400 text-center font-bold text-slate-950 bg-slate-100 cursor-pointer hover:bg-kobaaccent-400" onClick={onClick}>
		{!!value ? formatOdd(value) : '-'}
	</div>
}
export function MoreButton({children, onClick}) {
	return <div class="cl-pt-more-btn flex h-full w-9 flex-none items-center justify-center pb-1 text-center text-base font-bold leading-tight mr-2 cursor-pointer hover:bg-slate-200 hover:text-slate-950" onClick={onClick}>{children}</div>
}

export function ShowMoreFooter({children, onClick}) {
	return <div class="cl-pt-show-more-footer flex h-8 items-center justify-around text-sm text-kobaaccent-400" onClick={onClick}>{children}</div>
}


export function LastMinuteEventsExample() {
	return <div>
	  <CardHeaderRow>
		<ThreeDots />
		<CardHeaderTitle>Last Minute</CardHeaderTitle>
		<CardHeaderSports>
		  <SportNameButton>Soccer</SportNameButton>
		  <SportNameButton>Soccer</SportNameButton>
		</CardHeaderSports>
	  </CardHeaderRow>
	  <OddsTableHeadRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <HeadOddCell>1</HeadOddCell>
		  <HeadOddCell>X</HeadOddCell>
		  <HeadOddCell>2</HeadOddCell>
		  <HeadMoreCell />
		</OddsWidthContainer>
	  </OddsTableHeadRow>
	  <div>
		<EventRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <EventOddButton>2.50</EventOddButton>
		  <EventOddButton>1.82</EventOddButton>
		  <EventOddButton>3.20</EventOddButton>
		  <MoreButton>+</MoreButton>
	    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <div>
		<EventRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <EventOddButton>2.50</EventOddButton>
		  <EventOddButton>1.82</EventOddButton>
		  <EventOddButton>3.20</EventOddButton>
		  <MoreButton>+</MoreButton>
	    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <div>
		<EventRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <EventOddButton>2.50</EventOddButton>
		  <EventOddButton>1.82</EventOddButton>
		  <EventOddButton>3.20</EventOddButton>
		  <MoreButton>+</MoreButton>
	    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <ShowMoreFooter>Show More {">>"}</ShowMoreFooter>
	</div>
}


export function TournamentSelectorHead({children}) {
	return <div class="cl-pt-tourn-sel-head flex h-8 items-center justify-between border-b border-b-zinc-950 bg-zinc-800 text-kobaaccent-500">{children}</div>
}
export function TournamentHeadCell({children}) {
	return <div class="cl-pt-tourn-head-cell flex h-full w-full grow items-center">{children}</div>
}
export function TournamentHeadButtonCell({children}) {
	return <div class="cl-pt-tourn-head-btn-cell h-full w-9 flex-none border-l border-l-zinc-950">{children}</div>
}

export function CategoryNameRow({children}) {
	return <div class="cl-pt-cat-name-row flex h-8 items-center justify-between border-b border-b-zinc-950 bg-zinc-800 text-white">{children}</div>
}

export function CategoryContentsRow({children}) {
	return <div class="cl-pt-cat-cont-row grid grid-cols-3 gap-1 border-b border-t border-b-zinc-950 border-t-zinc-800 bg-zinc-900 px-2 py-2 text-sm text-white">{children}</div>
}

export function TournamentCell({children}) {
	return <div class="cl-pt-tourn-cell flex h-8 items-center justify-start px-3">{children}</div>
}
export function TournamentCheckbox({children, active, onInput}) {
	return <div class="cl-pt-tourn-check h-6 w-6 flex-none">{children}</div>
}
export function TournamentNameLabel({children, active, onInput}) {
	return <div class="cl-pt-tourn-name-lbl h-6 w-6 flex-none">{children}</div>
}

export function SportTournamentSelector() {
	return <div>
	  <TournamentSelectorHead>
		<TournamentHeadCell>
		  <OneDotAlt />
		  <CardHeaderTitle>Football</CardHeaderTitle>
		</TournamentHeadCell>
		<TournamentHeadButtonCell />
		<TournamentHeadButtonCell />
		<TournamentHeadButtonCell />
	  </TournamentSelectorHead>
	  <div>
		<CategoryNameRow>
		  <TournamentHeadCell>
			<ThreeDots />
			<CardHeaderTitle>Italy</CardHeaderTitle>
		  </TournamentHeadCell>
		  <TournamentHeadButtonCell />
		</CategoryNameRow>
		<CategoryContentsRow>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		  <TournamentCell>
			<TournamentCheckbox />
			<TournamentNameLabel>Hello</TournamentNameLabel>
		  </TournamentCell>
		</CategoryContentsRow>
	  </div>
	</div>
}


export function TournamentSportName({children}) {
	return <div class="cl-pt-tourn-sport-name min-w-0 truncate text-sm uppercase">{children}</div>
}
export function TournamentFullName({children}) {
	return <div class="cl-pt-tourn-full-name min-w-0 grow truncate text-center text-base uppercase">{children}</div>
}
export function TournamentCardButtonCell({children}) {
	return <div class="cl-pt-trn-card-btn-cel min-w-0 grow truncate text-center text-sm flex items.center justify-center text-slate-950 cursor-pointer">{children}</div>
}

export function TournamentBigTabsContainer({children}) {
	return <div class="cl-pt-tnr-bigtab-cont relative">{children}</div>
}
export function TabsCollapseButton({children, onClick}) {
	return <div 
			   class="cl-pt-tab-coll-btn bg-slate-100 absolute -bottom-3 right-0 flex h-6 w-8 items-center justify-center rounded-full text-slate-800 cursor-pointer" 
			   onClick={onClick}>
		{children}
	</div>
}
export function TabsWrapper({children}) {
	return <div class="cl-pt-tab-wrap fn-tabs flex flex-wrap gap-2 p-3 border-b border-b-slate-300 bg-slate-100 text-sm">{children}</div>
}
export function TabButton({children, active, onClick}) {
	if (active)
		return <div class="cl-pt-tab-button flex h-8 items-center justify-center rounded-full border border-kobaaccent-400 bg-kobaaccent-400 text-slate-950 w-fit px-3 cursor-pointer" onClick={onClick}>
			<span class="truncate">{children}</span>
		</div>
	return <div class="cl-pt-tab-button flex h-8 items-center justify-center rounded-full border border-slate-300 bg-slate-100 text-slate-950 w-fit px-3 cursor-pointer" onClick={onClick}>
		<span class="truncate">{children}</span>
	</div>
}

export function SubTabsContainer({children}) {
	return <div class="cl-pt-subtab-cont fn-tabs-markets flex flex-wrap gap-2 p-3 border-b border-b-slate-300 bg-slate-100 text-sm">
		{children}
	</div>
}

export function SubTabsOddsContainer({children}) {
	return <div class="cl-pt-subtab-cont fn-tabs-markets gap-2 p-3 grid grid-cols-6 border-b border-b-slate-300 bg-slate-100 text-sm bg-slate-50">
		{children}
	</div>
}

export function SubTabButton({children, active, onClick}) {
	if (active)
		return <div class="cl-pt-subtab-btn flex h-8 items-center justify-center rounded-full border border-kobaaccent-500 bg-kobaaccent-500 text-slate-950 w-fit px-3 cursor-pointer" onClick={onClick}>
			<span class="truncate px-2">{children}</span>
		</div>
	return <div class="cl-pt-subtab-btn flex h-8 items-center justify-center rounded-full border border-slate-300 bg-slate-200 text-slate-950 w-fit px-3 cursor-pointer" onClick={onClick}>
		<span class="truncate px-2">{children}</span>
	</div>
}


export function TableRowDate({children}) {
	return <div class="cl-pt-tr-date flex h-6 items-center bg-slate-200 text-xs leading-tight text-slate-950">{children}</div>
}
export function DateCell({children}) {
	return <div class="cl-pt-date-cell flex h-full grow items-center justify-start px-1 text-center">{children}</div>
}



export function SingleTournamentCard() {
	return <div>
	  <CardHeaderRow>
		<ThreeDots />
		<TournamentSportName>Football</TournamentSportName>
		<TournamentFullName>Region - Tournament</TournamentFullName>
		<CardHeaderSports>
		  <TournamentCardButtonCell />
		  <TournamentCardButtonCell />
		</CardHeaderSports>
	  </CardHeaderRow>
	  <TournamentBigTabsContainer>
		<TabsWrapper>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		  <TabButton>Tab</TabButton>
		</TabsWrapper>
		<TabsCollapseButton>C</TabsCollapseButton>
	  </TournamentBigTabsContainer>
	  <SubTabsContainer>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
		<SubTabButton>Tab</SubTabButton>
	  </SubTabsContainer>
	  <OddsTableHeadRow>
		<HeadRowCellId>ID</HeadRowCellId>
		<HeadRowCellTime>Time</HeadRowCellTime>
		<HeadRowCellEvent>Event</HeadRowCellEvent>
		<OddsWidthContainer>
		  <HeadOddCell>1</HeadOddCell>
		  <HeadOddCell>X</HeadOddCell>
		  <HeadOddCell>2</HeadOddCell>
		  <HeadMoreCell />
		</OddsWidthContainer>
	  </OddsTableHeadRow>
	  <TableRowDate>
		<DateCell>2023-04-18</DateCell>
	  </TableRowDate>
	  <div>
		<EventRow>
			<HeadRowCellId>Live</HeadRowCellId>
			<HeadRowCellTime>Time</HeadRowCellTime>
			<HeadRowCellEvent>Event</HeadRowCellEvent>
			<OddsWidthContainer>
			  <EventOddButton>2.50</EventOddButton>
			  <EventOddButton>1.82</EventOddButton>
			  <EventOddButton>3.20</EventOddButton>
			  <MoreButton>+</MoreButton>
		    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <TableRowDate>
		<DateCell>2023-04-18</DateCell>
	  </TableRowDate>
	  <div>
		<EventRow>
			<HeadRowCellId>Live</HeadRowCellId>
			<HeadRowCellTime>Time</HeadRowCellTime>
			<HeadRowCellEvent>Event</HeadRowCellEvent>
			<OddsWidthContainer>
			  <EventOddButton>2.50</EventOddButton>
			  <EventOddButton>1.82</EventOddButton>
			  <EventOddButton>3.20</EventOddButton>
			  <MoreButton>+</MoreButton>
		    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <div>
		<EventRow>
			<HeadRowCellId>Live</HeadRowCellId>
			<HeadRowCellTime>Time</HeadRowCellTime>
			<HeadRowCellEvent>Event</HeadRowCellEvent>
			<OddsWidthContainer>
			  <EventOddButton>2.50</EventOddButton>
			  <EventOddButton>1.82</EventOddButton>
			  <EventOddButton>3.20</EventOddButton>
			  <MoreButton>+</MoreButton>
		    </OddsWidthContainer>
		</EventRow>
	  </div>
	  <M.BlankSeparator />
	</div>
}
